export default {
  // GLOBAL
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description': "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text': 'Nessun elemento disponibile',
  'global#facet_loading_text': 'Loading...',

  // READMORE
  'readmore#label': 'Mostra tutto',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',

  // SEARCH
  // Page title
  'search#title_works': 'Opere',
  'search#title_translations': 'Traduzioni',
  'search#title_bibliographies': 'Bibliografia',
  'search#title_biographies': 'Vite antiche',
  'search#title_iconographies': 'Iconografia',
  'search#title_tools': 'Materiali e strumenti',
  // Total results
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#translations_total': '<strong>{ total }</strong> Traduzioni',
  'search#translations_total_1': '<strong>{ total }</strong> Traduzione',
  'search#translations_total_0': 'Nessuna Traduzione',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#bibliographies_total': '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1': '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  // Filters (tags)
  'primary_translation': 'Traduzione primaria',
  // Facets
  'search#facets_title': 'Filtra i risultati',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#placeholder_query_biblio': 'Cerca',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#placeholder_authors': 'Cerca per nome o per pseudonimo',
  'search#placeholder_author_alias': 'Cerca uno pseudonimo',
  'search#placeholder_author_work': 'Cerca un autore dell\'opera tradotta',
  'search#placeholder_translator': 'Cerca un traduttore',
  'search#placeholder_works': 'Cerca un\'opera di riferimento',
  'search#placeholder_id': 'Cerca un identificativo',
  'search#header_authors': 'Autori',
  'search#header_author_alias': 'Pseudonimo',
  'search#header_genre': 'Genere',
  'search#header_author_work': 'Autore opera tradotta',
  'search#header_century': 'Secolo',
  'search#header_translator': 'Traduttore',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere di riferimento',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#header_print_place': 'Luogo di stampa',
  'search#header_publisher': 'Editore',
  'search#header_id': 'Identificativo',
  'search#header_print_type': 'Tipologia testuale',
  'search#header_translation_type': 'Tipo di traduzione',
  'search#header_translation_parts': 'Partizione tradotta',
  'search#header_bibliography_type': 'Tipo',
  'search#header_source': 'Fonti',
  'search#header_metric': 'Forma metrica',
  'search#header_place': 'Luogo di conservazione',
  'search#header_pressmark': 'Segnatura',
  // Order
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#sort_label_asc': 'Ordine per opera tradotta',
  // Results
  'search#filters_title': 'Filtri attivi:',
  'search#fallback_text': 'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_text': 'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_button': 'Resetta la ricerca',
  'search#resultsamount': 'Risultati per pagina',
  // Description
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',

  // RESOURCE
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'resource#metadata_citazione': 'Citazione',
  'resource#collection_translations': 'Traduzioni associate',
  'resource#collection_works': 'Opera di riferimento',
  'resource#collection_primary-translation': 'Traduzione di riferimento',
  'resource#bibliography': 'Bibliografia',
  
  // ADVANCED SEARCH
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#reset': 'Pulisci i campi',
  'advancedsearch#results_total': '<strong>{ total }</strong> risultati',
  'advancedsearch#results_total_1': '<strong>{ total }</strong> risultato',
  'advancedsearch#results_total_0': 'Nessun risultato',
  'advancedsearch#results_number': 'Risultati per pagina',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#label_title': 'Titolo',
};
